import createIcon from '../../createIcon';

/**
 * @component @name Sixk
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxMi41SDkuNVYxNEg4VjEyLjVaTTE5IDNINUMzLjkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVY1QzIxIDMuOSAyMC4xIDMgMTkgM1pNMTEgMTAuNUg4VjExLjVIMTBDMTAuNTUgMTEuNSAxMSAxMS45NSAxMSAxMi41VjE0QzExIDE0LjU1IDEwLjU1IDE1IDEwIDE1SDcuNUM2Ljk1IDE1IDYuNSAxNC41NSA2LjUgMTRWMTBDNi41IDkuNDUgNi45NSA5IDcuNSA5SDExVjEwLjVaTTE4IDE1SDE2LjI1TDE0LjUgMTIuNzVWMTVIMTNWOUgxNC41VjExLjI1TDE2LjI1IDlIMThMMTUuNzUgMTJMMTggMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sixk = createIcon('Sixk', [
  [
    'path',
    {
      d: 'M8 12.5H9.5V14H8V12.5ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM11 10.5H8V11.5H10C10.55 11.5 11 11.95 11 12.5V14C11 14.55 10.55 15 10 15H7.5C6.95 15 6.5 14.55 6.5 14V10C6.5 9.45 6.95 9 7.5 9H11V10.5ZM18 15H16.25L14.5 12.75V15H13V9H14.5V11.25L16.25 9H18L15.75 12L18 15Z',
      key: '2zcwhc',
    },
  ],
]);

export default Sixk;
